export const getMusicRecordAlbumsEndpoint = (recordId) => `Music/Label/Record/${recordId}:albums`